import { environment } from '../../environment'
import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { defaultSidebarState } from './data';
import { UseSidebarStore } from './model';
import { getMenu } from './services';

export const useSidebarStore = create<UseSidebarStore>(
  devtools
    (persist((set, get) => ({
      ...defaultSidebarState,
      toggle: () => set({ collapsed: !get().collapsed }),
      setCollapsed: (collapsed) => set({ collapsed }),
      setMenu: () => set({ menu: getMenu() })
    }), {
      name: '@zustand/useSidebarStore',
      version: environment.zustandStoreVersion
    }))
)

export const SidebarStore = useSidebarStore.getState()
